import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { withReauth } from '@/lib/auth';

/**
 * Custom base query with JWT auth and automatic token refresh on 401.
 */
const baseQueryWithAuth = withReauth((accessToken) =>
  fetchBaseQuery({
    baseUrl:
      import.meta.env.VITE_MARKETPLACE_API_URL ||
      'http://localhost:3013/marketplace-api',
    prepareHeaders: (headers) => {
      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
);

/**
 * RTK Query API for the Marketplace API (VITE_MARKETPLACE_API_URL)
 *
 * Used for:
 * - Service providers (global service provider registry)
 */
export const marketplaceApi = createApi({
  reducerPath: 'marketplaceApi',
  baseQuery: baseQueryWithAuth,

  tagTypes: ['ServiceProvider'],

  // Cache configuration
  keepUnusedDataFor: 300, // Keep cache for 5 minutes
  refetchOnMountOrArgChange: false, // Use cache on navigation
  refetchOnFocus: false, // Don't refetch on window focus
  refetchOnReconnect: true, // Refetch when connection restored

  endpoints: () => ({}),
});
